module.exports = __webpack_public_path__ + "img/how-it-works-1.1aa2098d.jpg";